<template>
  <div>
    <img v-show="!showList" src="@/assets/image/mobileBack.png" class="header-img" @click="back()" />
    <div class="header">
      <div class="header-font">旅游资讯</div>
    </div>
    <div class="body" v-show="showList">
      <div v-for="item in datalist" :key="item.id" class="body-card">
        <div class="body-row" style="padding:3.26vh 4.4vw 3.26vh 4.4vw" @click="open(item)">
          <div class="body-column" style="width:45.8666vw">
            <div class="body-card-title">
              {{item.title}}
            </div>
            <div style="height:1.5vh"></div>
            <div class="body-card-introduce">
              {{item.introduce}}
            </div>
            <div style="height:1.5vh"></div>
            <div class="body-card-time">
              {{item.createDate}}
            </div>
          </div>
          <div style="width:4.93vw"></div>
          <div style="width: 32vw;">
            <img :src="item.icon" class="body-img">
          </div>

        </div>
      </div>
    </div>
    <!-- 详情 -->
    <div class="body" v-show="!showList" style="padding:4vw">
      <div style="height:5.3333vw"></div>
      <div class="body-mobile-top">
        {{ info.title }}
      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-row" style="align-items:center; justify-content:center;">
        
        <div class="body-tittle-little">日期</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{subData(info.createDate)}}</div>
        <div style="width:3.0666vw"></div>
        <div class="body-tittle-little">点击</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{info.hits}}</div>
        
      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-line"></div>
      <div style="height:5.3333vw"></div>
      <div v-html="info.details" style="font-size:3.73333vw;font-weight:400;color:#071420" class="infoDetails">
        <!-- {{ info.details }} -->
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>
<style>
.infoDetails img{
  width: 100%;
}
</style>
<script>
// import { getNewsTravel, } from "@/api/common";
import { getMenuOpenList } from "@/api/publicApi";
import { addHits } from "@/util/publicHits";
export default {
  name: "Tour",
  data() {
    return {
      current: 1,
      pageSize: 10,
      datalist: [],
      total: 0,
      showList: true,
      info: {}
    };
  },
  mounted() {
    this.getNewsTravelFunction()
  },
  methods: {
    subData(str){
      var result = ''
      if(str){
        result = str.substring(0,10)
      }
      return result
    },
    //旅游
    async getNewsTravelFunction() { 
      const { code, data } = await getMenuOpenList(0, 'news_travel', this.current, this.pageSize);
      // const { code, data } = await getNewsTravel(this.current, this.pageSize);
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global;
        this.datalist.forEach(element => {
          element.introduce != null ? (element.introduce = element.introduce.slice(0, 176) + ".....") : "";
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
        });
        this.total = data.total;
      }
    },
    open(item) {
      addHits(item.id)
      this.info = item
      this.showList = false
    },
    back() {
      this.info = {}
      this.showList = true
    }
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 5.7266vh;
  background: #dcdcdc;
  text-align: center;
}
.header-font {
  font-size: 2.216vh;
  line-height: 5.7266vh;
  text-align: center;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #071420;
}
.body-card {
  width: 91.466%;
  height: 17.733vh;
  background: #f6faff;
  border-radius: 4.266vw;
  margin: 4.2666vw 4.2666vw 0 4.2666vw;
}
.footer {
  height: 4.2666vw;
}
.body-row {
  display: flex;
  flex-direction: row;
}
.body-column {
  display: flex;
  flex-direction: column;
}
.body-img {
  width: 32vw;
  height: 11.33vh;
  border-radius: 2.1333vw;
}
.body-card-title {
  font-size: 4.266vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.body-card-introduce {
  font-size: 3.466vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #334251;
  /* height: 4.31vh; */
  display: -webkit-box; /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 2; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
}
.body-card-time {
  font-size: 3.2vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #8b939a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-img {
  width: 4.6666vw;
  height: 4.6666vw;
  position: absolute;
  z-index: 1;
  top: 4vw;
  left: 4vw;
}
.body-mobile-top {
  font-size: 4.2666vw;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.body-tittle-num {
  font-size: 3.733vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #071420;
}
.body-tittle-little {
  font-size: 3.733vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #8b939a;
}
.body-line {
  width: 100%;
  height: 0.1333vw;
  text-align: center;
  border-bottom: 1px dashed #8B939A;
}
.box1 {
  width: 300px;
  height: 50px;
  text-align: center;
  padding-top: 30px;
  border-bottom: 2px dashed #000;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/tour.vue